const makeConstant = (value: number, unit = 'px') => ({
  value,
  unit,
  get label() {
    return `${this.value}${this.unit}`;
  },
});

export const AXIS_HEIGHT = makeConstant(35);
export const CARD_WIDTH = makeConstant(280);
export const COMPACT_CARD_WIDTH = makeConstant(263);
export const DRAFT_CARD_HEIGHT = makeConstant(215);
export const SUBITEM_HEIGHT = makeConstant(28);
export const SUBITEM_GAP = makeConstant(8);
export const GRAND_CHILD_ROW_HEIGHT = makeConstant(20);
export const GRAND_CHILD_ROW_GAP = makeConstant(2);
// Full rendered "N more items" row: span line-height (16) + vertical padding (4)
// + trailing li margin-bottom (= SUBITEM_GAP, 8).
export const SUBITEM_MORE_ITEMS_ROW_HEIGHT = makeConstant(28);
export const MAX_DISPLAYED_SUB_ITEMS = 5;
export const MAX_DISPLAYED_GRAND_CHILDREN = 4;
export const COLUMN_HEADER_HEIGHT = makeConstant(26);
export const HEADER_MENU_BUTTON_SIZE = makeConstant(32);
export const GROUP_ROW_HEADER_HEIGHT = makeConstant(32);
export const GRID_GAP = makeConstant(10);
export const CELL_GAP = makeConstant(12);
export const CELL_WRAPPER_PADDING = makeConstant(9);
export const CELL_WRAPPER_PADDING_BOTTOM = makeConstant(9);
export const ROW_HEIGHT_MIN = makeConstant(215);
export const ROW_HEADER_WIDTH = {
  vertical: makeConstant(32),
  horizontal: makeConstant(155),
};

export const GROUP_COL_INNER_GAP = makeConstant(4);
export const RESIZE_HANDLE_WIDTH = makeConstant(4);
export const RESIZE_HANDLE_HITBOX_PADDING = makeConstant(6);

export const DEFAULT_COLOR = '#2196F3';

export const SORTABLE_TYPES = {
  Card: 'Card',
  Cell: 'Cell',
  Header: 'Header',
} as const;

export type SortableTypesValue = (typeof SORTABLE_TYPES)[keyof typeof SORTABLE_TYPES];

export const COL_ROW_HIGHLIGHT_COLOR = '#f1f1f1';
export const CELL_DRAG_OVER_COLOR = '#f5f5f5';
